import React from 'react';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PrivacyNotice() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-orange-100 selection:text-orange-900 py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        
        {/* Terugknop */}
        <Link 
          to="/" 
          className="inline-flex items-center text-[#1e3a8a] hover:text-blue-700 font-bold mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Terug naar Home
        </Link>

        {/* Hoofddocument */}
        <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-6 sm:p-10 md:p-12">
          
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-5 mb-10 pb-8 border-b border-slate-100">
            <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center flex-shrink-0">
              <ShieldCheck className="w-8 h-8 text-[#1e3a8a]" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-extrabold text-[#1e3a8a]">Privacyverklaring</h1>
              <p className="text-slate-500 mt-2 font-medium">Laatst bijgewerkt: 26 juli 2026</p>
            </div>
          </div>

          {/* Inhoud */}
          <div className="space-y-10 text-slate-600 leading-relaxed">
            
            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-3">1. Wie zijn wij?</h2>
              <p>
                <strong>bespanapp.nl</strong> is een officiële handelsnaam en dienst van <strong>Stan Tennis Academie Noord</strong>. Wij (hierna te noemen: "wij" of "ons") hechten grote waarde aan jouw privacy. Als Stan Tennis Academie Noord zijn wij de juridische verwerkingsverantwoordelijke voor de persoonsgegevens die via de bespanapp.nl applicatie en bespanservice worden verzameld.
              </p>
              <ul className="mt-4 space-y-2 bg-slate-50 p-5 rounded-xl border border-slate-100">
                <li><strong className="text-slate-700">Juridische naam:</strong> Stan Tennis Academie Noord</li>
                <li><strong className="text-slate-700">Handelsnaam:</strong> bespanapp.nl</li>
                <li><strong className="text-slate-700">KVK-nummer:</strong> 66874084</li>
                <li><strong className="text-slate-700">Adres:</strong> Cort van der Lindenstraat 4, 9801 KP Zuidhorn</li>
                <li><strong className="text-slate-700">E-mailadres:</strong> Stan@detennisacademie.nl</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-3">2. Welke persoonsgegevens verzamelen wij en waarom?</h2>
              <p className="mb-4">
                Wanneer je een racket bij ons inlevert of aanmeldt via ons online formulier, verwerken wij de volgende gegevens:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li><strong className="text-slate-700">Naam en Telefoonnummer:</strong> Om je te kunnen informeren wanneer je racket klaar is, of bij eventuele vragen over je opdracht.</li>
                <li><strong className="text-slate-700">Adres en Tennisclub (optioneel):</strong> Voor interne statistieken en, indien van toepassing, het aanbieden van clubspecifieke service.</li>
                <li><strong className="text-slate-700">Racketspecificaties en Historie:</strong> Gegevens over je racket, type snaar en spankracht. Dit bewaren we in jouw persoonlijke dossier zodat we je in de toekomst altijd exact dezelfde (of juist een aangepaste) bespanning kunnen aanbieden.</li>
                <li><strong className="text-slate-700">Betaalgegevens:</strong> Bij het afronden van een opdracht genereren wij een betaallink. Wij verwerken de status van deze betaling om je opdracht administratief te kunnen sluiten.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-3">3. Hoe lang bewaren we je gegevens?</h2>
              <p className="mb-4">
                Wij bewaren je persoonsgegevens niet langer dan noodzakelijk is voor de doelen waarvoor ze zijn verzameld.
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <strong className="text-slate-700">Klantprofielen en Bespanhistorie:</strong> Wij bewaren je profiel en bespanhistorie tot maximaal 7 jaar na je laatste opdracht. Dit doen wij vanuit serviceoogpunt (zodat we jaren later nog weten met welke snaar je speelde) en om te voldoen aan de wettelijke administratieplicht van de Belastingdienst.
                </li>
                <li>
                  Wanneer je ons verzoekt om je gegevens te verwijderen, zullen wij je profiel en technische racketspecificaties direct wissen, met uitzondering van gegevens die wij wettelijk verplicht zijn te bewaren voor onze financiële administratie.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-3">4. Delen we jouw gegevens met derden?</h2>
              <p className="mb-4">
                Wij verkopen jouw gegevens nooit aan derden. We delen gegevens alleen met betrouwbare partners die noodzakelijk zijn voor onze dienstverlening:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <strong className="text-slate-700">Google Firebase:</strong> Onze applicatie en database worden veilig gehost in de cloudomgeving van Google. Zij treden op als verwerker van de data en voldoen aan de strenge Europese veiligheidseisen.
                </li>
                <li>
                  <strong className="text-slate-700">Mollie:</strong> Voor het veilig verwerken van transacties en het aanmaken van betaallinks maken wij gebruik van de betaalprovider Mollie.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-3">5. Hoe beveiligen we jouw gegevens?</h2>
              <p>
                Wij nemen de bescherming van jouw gegevens serieus en nemen passende maatregelen om misbruik, verlies, onbevoegde toegang en ongewenste openbaarmaking tegen te gaan. De database is afgeschermd met versleutelde authenticatie en specifieke beveiligingsregels, waardoor uitsluitend geautoriseerde beheerders toegang hebben tot jouw gegevens.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-3">6. Jouw rechten (inzien, aanpassen of verwijderen)</h2>
              <p>
                Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te laten verwijderen (het zogenaamde 'recht om vergeten te worden'). Daarnaast heb je het recht om eventuele toestemming voor de gegevensverwerking in te trekken. Stuur hiervoor een e-mail naar <a href="mailto:Stan@detennisacademie.nl" className="text-[#1e3a8a] hover:underline font-medium">Stan@detennisacademie.nl</a> en we maken dit zo snel mogelijk (uiterlijk binnen 4 weken) voor je in orde.
              </p>
            </section>
            
          </div>
        </div>
        
        {/* Footer van de pagina */}
        <div className="mt-8 text-center text-sm text-slate-400">
          © {new Date().getFullYear()} Stan Tennis Academie Noord. Alle rechten voorbehouden.
        </div>
        
      </div>
    </div>
  );
}